import { useCallback } from 'react';
import { Plugins } from '@capacitor/core';
import { isFeatureAvailable } from '../util/feature-check';
export const availableFeatures = {
    useFileSystem: isFeatureAvailable('FileSystem', 'useFileSystem')
};
export function useFilesystem() {
    const { Filesystem } = Plugins;
    const getUri = useCallback(async (options) => {
        const result = await Filesystem.getUri(options);
        return result;
    }, []);
    const deleteFile = useCallback(async (options) => {
        const result = await Filesystem.deleteFile(options);
        return result;
    }, []);
    const readFile = useCallback(async (options) => {
        const result = await Filesystem.readFile(options);
        return result;
    }, []);
    const writeFile = useCallback(async (options) => {
        const result = await Filesystem.writeFile(options);
        return result;
    }, []);
    return {
        getUri,
        deleteFile,
        readFile,
        writeFile,
        isAvailable: true
    };
}
//# sourceMappingURL=useFileSystem.js.map